(function () {
  if (!window.customElements) return;

  if (!customElements.get('announcement-rotator')) {
    class AnnouncementRotator extends HTMLElement {
      connectedCallback() {
        this.items = Array.prototype.slice.call(this.querySelectorAll('[data-announcement]'));
        this.speed = parseInt(this.getAttribute('data-speed'), 10) || 4200;
        this.index = 0;

        if (this.items.length < 2) return;

        this.advance = this.advance.bind(this);
        this.timer = setInterval(this.advance, this.speed);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      advance() {
        this.items[this.index].classList.remove('is-active');
        this.items[this.index].setAttribute('aria-hidden', 'true');
        this.index = (this.index + 1) % this.items.length;
        this.items[this.index].classList.add('is-active');
        this.items[this.index].removeAttribute('aria-hidden');
      }
    }

    customElements.define('announcement-rotator', AnnouncementRotator);
  }

  if (!customElements.get('custom-header-nav')) {
    class CustomHeaderNav extends HTMLElement {
      connectedCallback() {
        this.toggles = Array.prototype.slice.call(this.querySelectorAll('[data-mega-toggle]'));
        this.burger = this.querySelector('[data-menu-toggle]');
        this.panel = this.querySelector('[data-menu-panel]');

        this.onToggleClick = this.onToggleClick.bind(this);
        this.onPointerEnter = this.onPointerEnter.bind(this);
        this.onPointerLeave = this.onPointerLeave.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onBurgerClick = this.onBurgerClick.bind(this);
        this.onResize = this.onResize.bind(this);

        this.toggles.forEach((toggle) => {
          toggle.addEventListener('click', this.onToggleClick);
          const entry = toggle.closest('[data-nav-entry]');
          if (entry) {
            entry.addEventListener('mouseenter', this.onPointerEnter);
            entry.addEventListener('mouseleave', this.onPointerLeave);
          }
        });

        if (this.burger) this.burger.addEventListener('click', this.onBurgerClick);

        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('focusout', this.onFocusOut);
        document.addEventListener('click', this.onDocumentClick);
        window.addEventListener('resize', this.onResize);
      }

      disconnectedCallback() {
        clearTimeout(this.closeTimer);
        this.toggles.forEach((toggle) => {
          toggle.removeEventListener('click', this.onToggleClick);
          const entry = toggle.closest('[data-nav-entry]');
          if (entry) {
            entry.removeEventListener('mouseenter', this.onPointerEnter);
            entry.removeEventListener('mouseleave', this.onPointerLeave);
          }
        });
        if (this.burger) this.burger.removeEventListener('click', this.onBurgerClick);
        this.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('focusout', this.onFocusOut);
        document.removeEventListener('click', this.onDocumentClick);
        window.removeEventListener('resize', this.onResize);
      }

      get isDesktop() {
        return window.matchMedia('(min-width: 769px)').matches;
      }

      panelFor(toggle) {
        return document.getElementById(toggle.getAttribute('aria-controls'));
      }

      open(toggle) {
        clearTimeout(this.closeTimer);
        this.toggles.forEach((other) => {
          if (other !== toggle) this.close(other);
        });

        const panel = this.panelFor(toggle);
        if (!panel) return;

        toggle.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        requestAnimationFrame(function () {
          panel.classList.add('is-open');
        });
      }

      close(toggle) {
        const panel = this.panelFor(toggle);
        if (!panel) return;

        toggle.setAttribute('aria-expanded', 'false');
        panel.classList.remove('is-open');
        panel.hidden = true;
      }

      closeAll() {
        this.toggles.forEach((toggle) => this.close(toggle));
      }

      onToggleClick(event) {
        event.preventDefault();
        const toggle = event.currentTarget;
        if (toggle.getAttribute('aria-expanded') === 'true') {
          this.close(toggle);
        } else {
          this.open(toggle);
        }
      }

      onPointerEnter(event) {
        if (!this.isDesktop) return;
        const toggle = event.currentTarget.querySelector('[data-mega-toggle]');
        if (toggle) this.open(toggle);
      }

      onPointerLeave() {
        if (!this.isDesktop) return;
        clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(() => this.closeAll(), 120);
      }

      onKeydown(event) {
        if (event.key !== 'Escape') return;

        const openToggle = this.toggles.filter((t) => t.getAttribute('aria-expanded') === 'true')[0];
        if (openToggle) {
          this.close(openToggle);
          openToggle.focus();
          return;
        }

        if (this.burger && this.burger.getAttribute('aria-expanded') === 'true') {
          this.closeMenu();
          this.burger.focus();
        }
      }

      onFocusOut(event) {
        if (!this.isDesktop) return;
        if (event.relatedTarget && this.contains(event.relatedTarget)) return;
        this.closeAll();
      }

      onDocumentClick(event) {
        if (this.contains(event.target)) return;
        this.closeAll();
        this.closeMenu();
      }

      onBurgerClick() {
        if (this.burger.getAttribute('aria-expanded') === 'true') {
          this.closeMenu();
        } else {
          this.burger.setAttribute('aria-expanded', 'true');
          this.classList.add('is-menu-open');
        }
      }

      closeMenu() {
        if (!this.burger) return;
        this.burger.setAttribute('aria-expanded', 'false');
        this.classList.remove('is-menu-open');
        this.closeAll();
      }

      onResize() {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          this.closeAll();
          if (this.isDesktop) this.closeMenu();
        }, 150);
      }
    }

    customElements.define('custom-header-nav', CustomHeaderNav);
  }
})();
